import { Flex, Spinner } from '@chakra-ui/react';
import { DocumentTypeEnum } from '@shared/types/PersonType';

import { Header } from '../../components';
import { useGetAllOnboardingInfo } from '../../hooks';

import { DataCompanyForm } from './DataCompanyForm';
import { DataUserForm } from './DataUserForm';

const ROOT_ENTITY = 'onboarding/data';

export const Data = () => {
  const { data, isFindingOnboardingInfo } = useGetAllOnboardingInfo();

  return (
    <Flex
      flexDir="column"
      w="full"
      p={10}
      maxH="100dvh"
      h="100%"
      align="center"
    >
      <Flex flexDir="column" gap={6} w="full" maxW="700px">
        <Header rootEntity={ROOT_ENTITY} />

        {isFindingOnboardingInfo ? (
          <Flex
            w="full"
            h="calc(100dvh - 196px)"
            justify="center"
            align="center"
          >
            <Spinner size="xl" />
          </Flex>
        ) : data.requestCustomers[0].documentType === DocumentTypeEnum.CNPJ ? (
          <DataCompanyForm rootEntity={ROOT_ENTITY} />
        ) : (
          <DataUserForm rootEntity={ROOT_ENTITY} />
        )}
      </Flex>
    </Flex>
  );
};
